import axios from '@/plugins/api.request'
/**
 * 提交
 * @data {*} data
 */
 export const post = (data) => {
  return axios.request({
    method: 'post',
    url: 'edu.apply/post',
    data
  })
}